import { useAddon } from "hooks/useAddon";
import { useCallback, useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";

const HPCHOrder = ({
  currentProduct,
  hostingProduct,
  setHostingProduct,
}) => {
  const { pid } = hostingProduct;
  const { billingcycle: productBillingCycle } =
    hostingProduct?.productDetails ?? "annually";

  const { data: datas, loading } = useAddon(pid);
  const [plusPackAddons, setPlusPackAddons] = useState(null);
  const [selectedAddons, setSelectedAddons] = useState({
    id: 0,
    price: 0,
    addonName: null,
  });

  const getPlusPack = useCallback(() => {
    if (!loading) {
      const addons = datas.data;
      if (!addons) {
        setPlusPackAddons("");
        return;
      }
      const plusPackAddons = addons.filter((addon) =>
        addon.name.includes("Plus Pack")
      );
      setPlusPackAddons(plusPackAddons);
    }
  }, [datas, loading]);

  const setAddPriceByTermin = useCallback(() => {
    if (productBillingCycle && selectedAddons.id !== 0) {
      const addonsDetail = plusPackAddons.find(
        (addon) => +addon.id === selectedAddons.id
      );
      switch (productBillingCycle) {
        case "annually":
          setSelectedAddons({
            ...selectedAddons,
            price: +addonsDetail?.annually,
          });
          setHostingProduct({ type: "SET_ADDONS", payload: selectedAddons });
          setHostingProduct({
            type: "ADD_ADDON_PRICE",
            payload: +addonsDetail?.annually,
          });
          break;
        case "semiannually":
          setSelectedAddons({
            ...selectedAddons,
            price: addonsDetail?.semiannually,
          });
          setHostingProduct({ type: "SET_ADDONS", payload: selectedAddons });
          setHostingProduct({
            type: "ADD_ADDON_PRICE",
            payload: +addonsDetail?.semiannually,
          });
          break;
        case "quarterly":
          setSelectedAddons({
            ...selectedAddons,
            price: +addonsDetail?.quarterly,
          });
          setHostingProduct({ type: "SET_ADDONS", payload: selectedAddons });
          setHostingProduct({
            type: "ADD_ADDON_PRICE",
            payload: +addonsDetail?.quarterly,
          });
          break;
        case "monthly":
          setSelectedAddons({
            ...selectedAddons,
            price: +addonsDetail?.monthly,
          });
          setHostingProduct({ type: "SET_ADDONS", payload: selectedAddons });
          setHostingProduct({
            type: "ADD_ADDON_PRICE",
            payload: +addonsDetail?.monthly,
          });
          break;
        default:
          break;
      }
    }
    // eslint-disable-next-line
  }, [productBillingCycle, selectedAddons.price]);

  useEffect(() => {
    if (productBillingCycle && selectedAddons.id === 0) {
      if (plusPackAddons) {
        const addonsDetail = plusPackAddons.find(
          (addon) => +addon.id === selectedAddons.id
        );
        switch (productBillingCycle) {
          case "annually":
            setHostingProduct({
              type: "ADD_ADDON_PRICE",
              payload: +addonsDetail?.annually,
            });
            break;
          case "semiannually":
            setHostingProduct({
              type: "ADD_ADDON_PRICE",
              payload: +addonsDetail?.semiannually,
            });
            break;
          case "quarterly":
            setHostingProduct({
              type: "ADD_ADDON_PRICE",
              payload: +addonsDetail?.quarterly,
            });
            break;
          case "monthly":
            setHostingProduct({
              type: "ADD_ADDON_PRICE",
              payload: +addonsDetail?.monthly,
            });
            break;
          default:
            break;
        }
      }
    }
  }, [productBillingCycle, setHostingProduct, plusPackAddons, selectedAddons.id]);

  useEffect(() => {
    getPlusPack();
  }, [getPlusPack]);

  useEffect(() => {
    setAddPriceByTermin();
  }, [setAddPriceByTermin]);

  useEffect(() => {
    if (Boolean(hostingProduct.productDetails?.addon)) {
      setHostingProduct({
        type: "SET_ADDONS",
        payload: null,
      });
    }
    if (hostingProduct.productDetails) {
      setHostingProduct({
        type: "ADD_ADDON_PRICE",
        payload: 0,
      });
    }
    // eslint-disable-next-line
  }, [pid, setHostingProduct]);

  const selectAddonHandler = (e) => {
    const selectedAddonId = +e.target.value;
    const addonsDetail = plusPackAddons.find(
      (addon) => +addon.id === selectedAddonId
    );
    let addonPrice;

    if (selectedAddonId === 0) {
      setSelectedAddons({
        id: selectedAddonId,
        price: 0,
        addonName: null,
      });
      setHostingProduct({ type: "SET_ADDONS", payload: null });
      setHostingProduct({
        type: "ADD_ADDON_PRICE",
        payload: null,
      });
      return;
    }

    switch (productBillingCycle) {
      case "annually":
        addonPrice = addonsDetail.annually;
        break;
      case "semiannually":
        addonPrice = addonsDetail.semiannually;
        break;
      case "quarterly":
        addonPrice = addonsDetail.quarterly;
        break;
      default:
        addonPrice = addonsDetail.monthly;
        break;
    }

    const addonPayload = {
      id: selectedAddonId,
      price: addonPrice,
      addonName: addonsDetail.name,
    };

    setSelectedAddons(addonPayload);
    setHostingProduct({ type: "SET_ADDONS", payload: addonPayload });
    setHostingProduct({
      type: "ADD_ADDON_PRICE",
      payload: +addonPayload.price,
    });
  };

  return (
    <>
      {currentProduct.current.gid !== 696 &&
        currentProduct.current.gid !== 700 &&
        currentProduct.current.gid !== 703 && (
          <>
            <div className="row">
              <div className="col-6 d-flex ">
                {loading && !plusPackAddons && <Spinner />}
                {!loading && plusPackAddons && (
                  <>
                    <select
                      name="addons"
                      id="addonsHPCH"
                      value={selectedAddons.id}
                      className="form-select me-3"
                      onChange={selectAddonHandler}
                    >
                      <option value="0">No Addons</option>
                      {plusPackAddons.map((addon) => (
                        <option key={addon.id} value={addon.id}>
                          {addon.name}
                        </option>
                      ))}
                    </select>
                    <OverlayTrigger
                      placement={"right"}
                      overlay={
                        <Tooltip>
                          Maksimalkan potensi dari bisnis dan website anda dengan
                          Enterprise Backup, Premium SSL, dan Custom Firewall dari
                          Addon Plus Pack
                        </Tooltip>
                      }
                    >
                      <span
                        className="d-inline-block px-1 py-0 ms-1 fw-bold text-white align-self-center"
                        style={{
                          backgroundColor: "#ee4d30",
                          cursor: "pointer",
                          borderRadius: "50%",
                          fontSize: "10px",
                        }}
                      >
                        ?
                      </span>
                    </OverlayTrigger>
                  </>
                )}
              </div>
            </div>
            <div className="row mt-3">
              <div className="col-8">
                {(() => {
                  const plusPackDetails = {
                    "Plus Pack 1": ["+ 25 GB Enterprise Daily Backup"],
                    "Plus Pack 2": [
                      "+ 100 GB Enterprise Daily Backup",
                      "+ Premium SSL DV",
                      "+ 1 Whitelist IP for Email only",
                    ],
                    "Plus Pack 3": [
                      "+ 225 GB Enterprise Daily Backup",
                      "+ Premium SSL DV",
                      "+ 2 Whitelist IP for Email only",
                    ],
                    "Plus Pack 4": [
                      "+ 450 GB Enterprise Daily Backup",
                      "+ Premium SSL DV",
                      "+ 3 Whitelist IP for Email only",
                    ],
                    "Plus Pack 5": [
                      "+ 1TB Enterprise Daily Backup",
                      "+ Premium SSL DV",
                      "+ 4 Whitelist IP for Email only",
                    ],
                  };

                  const details = plusPackDetails[selectedAddons.addonName];
                  return details ? (
                    details.map((detail, index) => (
                      <p
                        key={index}
                        className="py-1 mb-0"
                        style={{ color: "#ee4d30", fontWeight: "bolder" }}
                      >
                        {detail}
                      </p>
                    ))
                  ) : (
                    <></>
                  );
                })()}
              </div>
            </div>
          </>
        )}
    </>
  );
};

export default HPCHOrder;
